// Game utility functions

import { Question } from '../types/game';
import { getGameDisplayName, formatQuestionLabel as formatQuestionLabelI18n } from '../i18n/helpers';

export { formatQuestionLabelI18n as formatQuestionLabel };

/**
 * Get the display name for a game type
 */
export const getGameName = getGameDisplayName;

/**
 * Calculate remaining time for a question
 */
export const calculateTimeRemaining = (
  question: Question,
  questionStartTime?: number,
  options?: { isPaused?: boolean; pausedRemainingMs?: number }
): number => {
  if (options?.isPaused && options.pausedRemainingMs != null) {
    return options.pausedRemainingMs;
  }
  if (question.timeRemaining !== undefined) {
    // Backend provided calculated remaining time (reconnection scenario)
    return question.timeRemaining;
  } else if (questionStartTime) {
    // Calculate from questionStartTime
    const elapsed = Date.now() - questionStartTime;
    return Math.max(0, question.timeLimit - elapsed);
  } else {
    // Fallback: use full timeLimit (new question)
    return question.timeLimit;
  }
};

/**
 * Check if a question is new (different ID)
 */
export const isNewQuestion = (
  newQuestionId: string | undefined,
  previousQuestionId: string | undefined
): boolean => {
  return newQuestionId !== previousQuestionId;
};

/**
 * Get question ID from question object (handles both questionId and id)
 */
export const getQuestionId = (question: Question | null | undefined): string | undefined => {
  if (!question) return undefined;
  return question.questionId || question.id;
};
